module.exports = __webpack_public_path__ + "img/beregsz_logo.b30d0b81.png";